// extracted by mini-css-extract-plugin
export default {"wrap":"wrap___laezB","slicedBackground":"slicedBackground___zYw5x","container":"container___l83pM","homePageWrap":"homePageWrap___NGkdK"};